import 'owl.carousel';

export default jQuery(function() {
    const $slider_banners = jQuery('.js-slider');
    if($slider_banners.length) {
        $slider_banners.owlCarousel({
            animateOut: 'fadeOut',
            autoplay: true,
            autoplayTimeout: 8000,
            dots: true,
            items: 1,
            loop: true,
            nav: false,
            navText: [
                '',
                ''
            ]
        });
    }
});
